import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const NotificationBanner = () => {
  const [show, setShow] = useState(false);
  const [counts, setCounts] = useState({ events: 0, tasks: 0, documents: 0, total: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    fetchNotificationCount();
  }, []);

  const fetchNotificationCount = async () => {
    try {
      const response = await api.get('/notifications/count');
      if (response.data.success && response.data.count > 0) {
        setCounts({
          ...response.data.breakdown,
          total: response.data.count
        });

        // Check if user has dismissed this banner recently (within 24 hours)
        const dismissedTime = localStorage.getItem('notificationBannerDismissed');
        const now = Date.now();

        if (!dismissedTime || now - parseInt(dismissedTime) > 24 * 60 * 60 * 1000) {
          setShow(true);
        }
      }
    } catch (error) {
      console.error('Error fetching notification count:', error);
    }
  };

  const handleDismiss = () => {
    setShow(false);
    // Remember dismissal for 24 hours
    localStorage.setItem('notificationBannerDismissed', Date.now().toString());
  };

  const handleViewAll = () => {
    navigate('/notifications');
    handleDismiss();
  };

  if (!show || counts.total === 0) {
    return null;
  }

  return (
    <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6 rounded-r-lg shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center flex-1">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-blue-800">
              {counts.total} new {counts.total === 1 ? 'update' : 'updates'} since your last visit
            </h3>
            <div className="mt-1 text-sm text-blue-700">
              {counts.events > 0 && <span>{counts.events} {counts.events === 1 ? 'event' : 'events'}</span>}
              {counts.events > 0 && (counts.tasks > 0 || counts.documents > 0) && <span> • </span>}
              {counts.tasks > 0 && <span>{counts.tasks} {counts.tasks === 1 ? 'task' : 'tasks'}</span>}
              {counts.tasks > 0 && counts.documents > 0 && <span> • </span>}
              {counts.documents > 0 && <span>{counts.documents} {counts.documents === 1 ? 'document' : 'documents'}</span>}
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={handleViewAll}
            className="text-sm font-medium text-blue-700 hover:text-blue-800 hover:underline"
          >
            View All
          </button>
          <button
            onClick={handleDismiss}
            className="text-blue-700 hover:text-blue-900 transition-colors"
            aria-label="Dismiss"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationBanner;
